import { setSubscriptionPlan } from '../Actions';
import { store } from '../Routes';
import CONFIG from '../config';

export const handleOfferPackage = ({ plans, pricingPlan, origin, history }) => {
  const { planID, title, listPrice, offerPrice, masterID } = plans;
  pricingPlan([{ courseID: '', planID: planID, price: offerPrice, listPrice: listPrice, courseTitle: title, masterID: masterID, offer: true }]);

  history.push(`/checkout`);
};

export const handleIndividualPackage = ({ plans, pricingPlan, origin, history, totalAmountToPay }) => {
  const { planID, title, listPrice, salePrice, offerPrice, masterID, offerStatus, priceID } = plans;
  const price = offerStatus ? offerPrice : salePrice;
  totalAmountToPay(salePrice);

  pricingPlan([{ courseID: '', planID: planID, price: price, listPrice: listPrice, courseTitle: title, masterID: masterID, offer: offerStatus, priceID: priceID }]);

  history.push(`/checkout`);
};

export const handlePremiumPackage = ({
  pricing,
  pricingPlan,
  origin,
  history,
  totalAmountToPay,
  subscriptionType,
  saveSubscriptionType,
  isFree,
  firstModuleUrl,
  subscribeVal,
  utm_src,
}) => {
  if (isFree && isFree) {
    window.location.href = firstModuleUrl;
  } else {
    const { title, listPrice, salePrice, offerPrice, masterID, priceID, subID, months } = pricing;
    const stripePriceID = pricing.stripePriceID;
    const price = offerPrice;
    const offerListPrice = pricing.listPrice;
    const validity = months;

    let planType = '';
    if (pricing && pricing._id) {
      if (pricing._id.includes('week')) {
        planType = 'week';
      } else if (pricing._id.includes('month')) {
        planType = 'month';
      } else {
        planType = 'year';
      }
    }

    totalAmountToPay(pricing.offerPrice);
    saveSubscriptionType(subscriptionType);

    if (subID) {
      store.dispatch(setSubscriptionPlan(true));
    } else {
      store.dispatch(setSubscriptionPlan(false));
    }

    /* stored in selectedCourses redux object */
    pricingPlan([
      {
        courseID: '',
        planID: pricing._id,
        priceID: priceID,
        price: price,
        listPrice: offerListPrice,
        courseTitle: title,
        masterID: masterID,
        offer: CONFIG.primeOfferStatus,
        currencySymbol: pricing.currencySymbol,
        stripePriceID: stripePriceID,
        subID: subID,
        validity: validity,
        planType: planType,
      },
    ]);

    let checkoutRoute = '/checkout';
    // if (utm_src) checkoutRoute = `/checkout?utm_src=${utm_src}`;
    // else checkoutRoute = `/checkout`;

    if (history !== undefined) history.push(checkoutRoute);
    else window.location.href = CONFIG.domain + checkoutRoute;
  }
};
